import { render, staticRenderFns } from "./NewArticleCard.vue?vue&type=template&id=606577d7&"
import script from "./NewArticleCard.vue?vue&type=script&lang=js&"
export * from "./NewArticleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports